import styled from 'styled-components';

export const OnSitePlanStyled = styled.div`
  @media (max-width: 767px) {
    .dp-buttons--plan {
      margin-top: 12px;
    }

    .onsite-additional-impression {
      margin-left: 0;
    }
  }
`;
